import { ECMProductDto } from '@core/services/dto/ecm-product.dto';

export class ECMProductModel {
    value: string;

    constructor(dto: ECMProductDto) {
      this.value = dto.products;
    }
}
